/**
 * A decisão que o guard do roteador toma antes de deixar uma navegação passar.
 *
 * Mora fora do `router/index.js` porque lá ela é inalcançável por teste: aquele
 * arquivo importa cada página da aplicação, e nenhuma delas carrega em Node.
 * Aqui é função pura -- entra estado, sai decisão --, e cada regra que já
 * quebrou na prática tem um caso escrito ao lado.
 */

/**
 * Telas públicas que continuam válidas com a sessão aberta. Mandar para a home
 * quem está numa delas interrompe algo que a pessoa está no meio de fazer.
 */
export const PUBLICAS_MESMO_LOGADO = Object.freeze([
    '/corporation-selection',
    '/rhdigital/corporation-selection',
    '/two-factor',
    '/kiosk',
    '/choose',
    '/display',
    'call-panel',
]);

/**
 * `publicas` compara caminho exato -- é a lista do enums.js. Rota pública com
 * parâmetro na URL não cabe ali e se declara por `meta.publica`; o aceite de
 * convite é das duas: pública e com token no caminho.
 */
export function ehPublica(caminho, meta, publicas) {
    return publicas.includes(caminho) || meta?.publica === true;
}

export function valeLogado(caminho, meta) {
    return meta?.publica === true || PUBLICAS_MESMO_LOGADO.includes(caminho);
}

/**
 * Decide o que fazer com a navegação. Devolve `{ acao, destino }`, onde `acao`
 * é uma de:
 *
 * - `login`     sem sessão em tela protegida
 * - `home`      com sessão numa tela de autenticação que já cumpriu seu papel
 * - `desviar`   há um convite esperando desde antes do login
 * - `seguir`    nada a fazer aqui
 *
 * O `pendente` é o token do convite guardado quando a pessoa foi obrigada a
 * entrar. Ele vence a home: quem chegou por um convite veio fazer aquilo, e
 * não ver a lista de empresas.
 */
export function decidirNavegacao({ temSessao, caminho, meta, publicas, nomeDaRota, pendente }) {
    const publica = ehPublica(caminho, meta, publicas);

    if (!temSessao && !publica) {
        return { acao: 'login' };
    }

    if (temSessao && publica && !valeLogado(caminho, meta)) {
        return { acao: 'home' };
    }

    if (temSessao && nomeDaRota !== 'invitation' && pendente) {
        return { acao: 'desviar', destino: `/invitation/${pendente}` };
    }

    return { acao: 'seguir' };
}
